import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import ShootingCreate from '@/views/ShootingPin.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/admin/projects/:projectId/shootings/:uploadShootingId',
    name: 'shooting-create',
    component: ShootingCreate,
  },
  {
    path: '/admin/projects/:projectId/shootings/:uploadShootingId/panorama-linking',
    name: 'shooting-create',
    component: ShootingCreate,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
